import * as accountsApi from '@/network/api/accounts.api.js'
import * as transfersApi from '@/network/api/transfers/transfers.api.js'
import * as instantTransferManagementApi from '@/network/api/instantTransferManagement.api.js'
import * as customersApi from '@/network/api/customers/customers.api.js'

/** Request Accounts Balances
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
@return {promise} - Accounts Balances
*/
export const requestAccountsBalances = async (context, payload) => {
	const res = await accountsApi.requestAccountsBalances(payload)

	if (res) context.commit('SAVE_ACCOUNTS_BALANCE', res.data.data)
	return res
}

/**
@docs
@return {promise} - beneficiary info
*/
export const checkBeneficiaryAlias = async (context, payload) => {
	const res = await instantTransferManagementApi.checkBeneficiaryAlias(payload)

	return res
}

/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_transfers
@return {promise} - Create pontual transfer order
*/
export const createTransfer = async (context, payload) => {
	const res = await transfersApi.createPontualTransfer(payload)

	return res
}

/**
@return {promise}
*/
export const requestAccountAssociatedAlias = async (context, payload) => {
	const res = await instantTransferManagementApi.requestAccountAssociatedAlias(payload)

	if (res) context.commit('SAVE_ACCOUNT_ALIAS', res.data.data)

	return res
}

/**
@return {promise}
*/
export const addAccountAliasAssociation = async (context, payload) => {
	const res = await instantTransferManagementApi.addAccountAliasAssociation(payload)

	return res
}

/** Resends OTP for alias association
@return {promise}
*/
export const resendOTPForAccountAliasAssociation = async (context, payload) => {
	const res = await instantTransferManagementApi.resendOTPForAccountAliasAssociation(payload)

	return res
}

/**
@return {promise}
*/
export const deleteAccountAssociation = async (context, payload) => {
	const res = await instantTransferManagementApi.deleteAccountAssociation(payload)

	return res
}

/**
@return {promise}
*/
export const editsAccountDefaultAliasAssociation = async (context, payload) => {
	const res = await instantTransferManagementApi.editsAccountDefaultAliasAssociation(payload)

	return res
}

/**
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customers
@return {promise}
*/
export const requestCustomerInfo = async (context, payload) => {
	const res = await customersApi.requestCustomerInfo()

	if (res) context.commit('SAVE_CUSTOMER', res.data.data)

	return res
}

/** Request Accounts Balances Plafond
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts%7Bid%7Dplafond
@return {promise} - Accounts Balances
*/
export const requestAccountsPlafond = async (context, payload) => {
	const res = await accountsApi.requestAccountsPlafond(payload)

	if (res) context.commit('SAVE_ACCOUNTS_PLAFOND', res.data.data)
	return res
}

/** Request Accounts Transaction Limit
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts%7Bid%7Dtransactionlimit
@return {promise} - Accounts Balances
*/
export const requestAccountsTransactionLimit = async (context, payload) => {
	const res = await accountsApi.requestAccountsTransactionLimit(payload)

	if (res) context.commit('SAVE_ACCOUNTS_TRANSACTION_LIMIT', res.data.data)
	return res
}
/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
	context.commit('CLEAR_FEATURE_STATE')
}
